var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":""},on:{"click":_vm.download}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("mdi-cloud-download")]),_vm._v(" "+_vm._s(_vm.label)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }